import type { en } from './en.js';

export const ru: typeof en = {
  app: {
    name: 'Домино',
  },
  seo: {
    title:
      'Домино онлайн — «Козёл», «Телефон» и «Все пятёрки» бесплатно | BN-games',
    description:
      'Играйте в домино онлайн бесплатно — «Козёл», «Телефон» и «Все пятёрки» (Маггинс), от 2 до 4 игроков. Забейте козла ботам или друзьям. Без регистрации.',
    social:
      'Домино в браузере — «Козёл», «Телефон» и «Все пятёрки». С друзьями онлайн или с ботами.',
    h1:
      'Домино онлайн — «Козёл», «Телефон» и «Все пятёрки»',
    intro:
      'Все три игры идут стандартным набором «дубль-шесть» из 28 костей. «Козёл» — та самая дворовая игра: во время раздачи очки не считают, а в конце проигравшие записывают себе очки, оставшиеся на руках. Кто первым наберёт 101 — проиграл, ему «забили козла». «Телефон» — русский вариант «Всех пятёрок»: очки даёт сумма открытых концов, кратная пяти, первую раздачу открывает кость [2|3], а право первого хода каждую раздачу переходит по кругу. «Все пятёрки» (Маггинс) — классическая игра на очки: каждый раз, когда сумма открытых концов цепочки кратна пяти, вы получаете эту сумму.\n\nИграйте бесплатно прямо в браузере вдвоём, втроём или вчетвером — с ботами, на одном устройстве или онлайн с друзьями по коду комнаты. Раздача в онлайн-партиях — с проверяемой честностью.',
    rulesTitle:
      'Правила домино — «Козёл», «Телефон» и «Все пятёрки» | BN-games',
    rulesDescription:
      'Как играть в домино: правила «Козла», «Телефона» и «Всех пятёрок» (Маггинс) — раздача, ходы, подсчёт очков и конец партии.',
    rulesH1:
      'Правила домино: «Козёл», «Телефон» и «Все пятёрки»',
    playCta:
      'Играть в домино',
  },
  a11y: {
    canvasLabel: 'Доска для домино. Стрелки переключают фокус между костями в руке, точками постановки и кнопками действий. Enter — выбрать; Escape — отменить выбранную кость.',
  },
  narration: {
    subjects: {
      you: 'Вы',
      opponent: 'Соперник',
    },
    tile: {
      the: 'кость',
      doublePrefix: 'дубль ',
      blank: 'пусто',
    },
    arms: {
      one: 'первый луч',
      two: 'второй луч',
      three: 'третий луч',
      four: 'четвёртый луч',
    },
    folds: {
      straight: 'прямо',
      left: 'влево',
      right: 'вправо',
    },
    cursor: {
      handTile: '{{tile}}, позиция {{index}} из {{count}}.',
      handTileForcedLead: '{{tile}}. Обязательный ход — нажмите Enter, чтобы зайти.',
      handTileMustLead: '{{tile}}, позиция {{index}} из {{count}}. Зайти нужно {{forced}}.',
      armSlot: 'Слот {{index}} из {{count}} — поставить {{tile}} на {{arm}}, поворот {{fold}}.',
      armSlotScores: 'Слот {{index}} из {{count}} — поставить {{tile}} на {{arm}}, поворот {{fold}}. Очков: {{points}}.',
      actionDraw: 'Взять из базара.',
      actionMuggins: 'Забрать Маггинс — {{points}} очков, {{seconds}} сек.',
    },
    move: {
      selfLead: 'Вы зашли {{tile}}.',
      selfPlay: 'Вы поставили {{tile}} на {{arm}}.',
      otherLead: '{{subject}} зашёл {{tile}}.',
      otherPlay: '{{subject}} поставил {{tile}} на {{arm}}.',
      openEnds: 'Открытые концы: {{ends}}.',
      scoredSelf: 'Вы набрали {{points}}.',
      scoredOther: 'Они набрали {{points}}.',
      noScore: 'Без очков.',
      mugginsPromptSelf: 'Нажмите Backspace, чтобы забрать в течение {{seconds}} сек.',
    },
    draw: {
      self: 'Вы взяли кость. На руке {{count}}.',
      other: '{{subject}} взял кость. У него {{count}}.',
    },
    pass: {
      self: 'Вы спасовали.',
      other: '{{subject}} спасовал.',
    },
    muggins: {
      claimSelf: 'Вы забрали {{points}} очков по Маггинсу.',
      claimOther: '{{subject}} забрал {{points}} очков по Маггинсу.',
      expired: 'Маггинс сгорел.',
    },
    turn: {
      you: 'Ваш ход.',
      other: 'Ход: {{subject}}.',
    },
    handOver: {
      wentOut: 'Раздача {{hand}} окончена. {{names}} вышел.',
      blocked: 'Раздача {{hand}} окончена. Тупик.',
      awarded: '{{names}} получил {{points}}.',
      penaltyStem: 'Раздача {{hand}} окончена.',
    },
    matchOver: {
      win: 'Партия окончена. Победил {{names}} со счётом {{score}}.',
      team: 'Партия окончена. Победила пара {{names}} со счётом {{score}}.',
      draw: 'Партия окончена. Ничья.',
      penaltyStem: 'Партия окончена.',
    },
  },
  common: {
    back: '← Назад',
    opponent: 'Соперник',
    seat: 'Место',
    you: 'Вы',
    cycle: 'нажмите Enter для смены',
  },
  game: {
    pingOpponent: 'Подтолкнуть соперника',
  },
  gameOverlay: {
    title: 'Пауза',
    openTooltip: 'Меню паузы',
    settingsLabel: 'Настройки',
    settingsBackLabel: '← Назад',
    settingsViewTitle: 'Настройки',
    restartLabel: 'Сыграть заново',
    restartHintOnline: 'Онлайн: нужно согласие всех. Одно предложение за партию.',
    restartHintAlreadyProposed: 'Вы уже предлагали рестарт в этой партии.',
    restartHintPending: 'Ждём ответа других игроков…',
    returnToMenuLabel: 'В главное меню',
    returnToMenuConfirmTitle: 'Выйти из партии и вернуться в меню?',
    returnToMenuConfirmYes: 'Да, выйти',
    returnToMenuConfirmNo: 'Остаться',
    giveUpLabel: 'Сдаться',
    giveUpConfirmTitle: 'Точно сдаёшься, трус?',
    giveUpConfirmYes: 'Да, я трус',
    giveUpConfirmNo: 'Продолжу борьбу',
    settingsTabs: {
      gameplay: 'Игра',
      interface: 'Интерфейс',
      audio: 'Звук',
    },
    discardConfirmTitle: 'Прервать текущую партию?',
    discardConfirmBody: 'Изменение этой настройки завершит текущую игру и начнёт новую.',
    discardConfirmYes: 'Прервать и начать заново',
    discardConfirmNo: 'Отмена',
    close: 'Закрыть',
  },
  auth: {
    signIn: 'Войти',
    signOut: 'Выйти',
    google: 'Google',
    github: 'GitHub',
    completeProfile: 'Заполните профиль →',
    profile: 'Профиль',
    backToLanding: '← BN-games',
  },
  social: {
    close: 'Закрыть',
    invite: {
      message: '{{sender}} приглашает вас в {{game}}',
      moreCount_one: '+{{count}} ещё приглашение',
      moreCount_few: '+{{count}} ещё приглашения',
      moreCount_many: '+{{count}} ещё приглашений',
      moreCount_other: '+{{count}} ещё приглашений',
      accept: 'Принять',
      decline: 'Отклонить',
      acceptAria: 'Принять приглашение от {{sender}} в {{game}}',
      declineAria: 'Отклонить приглашение от {{sender}} в {{game}}',
    },
    dock: {
      pillLabel: 'От {{sender}}',
      pillAria: 'Приглашение от {{sender}} в {{game}} — показать',
      popoverLabel: 'Приглашение',
      close: 'Закрыть приглашение',
      leaveGameTitle: 'Покинуть игру?',
      leaveGameBody: 'Приглашение откроет {{game}}, а текущая партия будет прервана. В онлайн-игре ваше место какое-то время сохраняется — вы сможете вернуться.',
      leaveGameConfirm: 'Выйти и присоединиться',
      leaveGameCancel: 'Остаться',
    },
    friendPicker: {
      button: 'Пригласить друга',
      modalTitle: 'Пригласить друга',
      loading: 'Загрузка друзей…',
      signInPrompt: 'Войдите, чтобы пригласить друга.',
      empty: 'У вас пока нет друзей.',
      findFriends: 'Найти друзей',
      invite: 'Пригласить',
      inviteAria: 'Пригласить {{name}}',
      invited: 'Приглашён',
      invitedAria: '{{name}} приглашён',
      notAccepting: 'Этот игрок сейчас не принимает приглашения',
      retryIn: 'Повторите через {{seconds}} с',
    },
    addOpponent: {
      buttonMany: 'Добавить друзей…',
      modalTitle: 'Добавить друзей',
      add: 'Добавить {{name}} в друзья',
      added: 'Добавлен',
      addedAria: '{{name}} добавлен в друзья',
    },
  },
  mainMenu: {
    quickStart: 'Быстрый старт',
    newGame: 'Новая игра',
    rules: 'Правила',
    settings: 'Настройки',
    history: 'История партий',
    about: 'Об игре',
  },
  playMenu: {
    title: 'Игра',
    playerCountLabel: 'Игроков',
    vsAi: 'Против бота',
    vsHuman: 'За одним устройством',
    createOnline: 'Создать онлайн-игру',
    joinOnline: 'Присоединиться к игре',
    gamesHistory: 'История партий',
    resume: 'Продолжить игру',
    resumeOnline: 'Продолжить онлайн ({{code}})',
    vsAiSession: 'Против бота ({{difficulty}})',
    localMode: 'За одним устройством',
    onlineMode: 'Против {{opponent}}',
    justNow: 'только что',
    minutesAgo: '{{count}} мин назад',
    hoursAgo: '{{count}} ч назад',
    daysAgo: '{{count}} дн назад',
    discardModal: {
      title: 'Отказаться от текущей игры?',
      body: 'Начало новой игры удалит текущую незавершённую партию. Это действие нельзя отменить.',
      keep: 'Оставить игру',
      discard: 'Отказаться',
    },
  },
  playerCount: {
    two: '2 игрока',
    three: '3 игрока',
    four: '4 игрока (каждый сам)',
    fourPartners: '4 игрока (2 на 2)',
    short: {
      two: '2',
      three: '3',
      four: '4',
      fourPartners: '2v2',
    },
  },
  seats: {
    south: 'Юг',
    west: 'Запад',
    north: 'Север',
    east: 'Восток',
  },
  settings: {
    title: 'Настройки',
    tabs: {
      gameplay: 'Игра',
      interface: 'Интерфейс',
      audio: 'Звук',
    },
    rows: {
      playerName: 'Имя игрока',
      sound: 'Звук',
      difficulty: 'Сложность бота',
      theme: 'Оформление',
      language: 'Язык',
      variant: 'Вариант',
      playerCount: 'Игроков по умолчанию',
      pointGoal: 'Целевой счёт',
      mugginsStrict: 'Строгий Muggins',
      mugginsAutoClaim: 'Авто-Muggins',
      hotSeatHide: 'Скрывать руку между ходами',
      afkAssistEnabled: 'Подсказка хода при бездействии',
      afkRemindersEnabled: 'Звук напоминания AFK',
      showAfkPingButton: 'Показывать кнопку «пинг»',
      turnStartSound: 'Звук начала хода',
      verifiableDiceEnabled: 'Проверяемое перемешивание',
      showBoneyardCount: 'Показывать счётчик базара',
      goatOpening13: 'Запись с 13 очков',
      goatBaldFinish: '«Лысый» — закончить на [0|0]',
    },
    difficulties: {
      easy: 'Лёгкий',
      medium: 'Средний',
      hard: 'Сложный',
    },
    themes: {
      mahogany: 'Mahogany',
      persian: 'Persian',
      deco: 'Deco',
      monte: 'Monte',
    },
    languages: {
      en: 'English',
      ru: 'Русский',
    },
    variants: {
      goat: 'Козёл',
      'goat-2v2': 'Козёл (2 на 2)',
      'all-fives': 'Все пятёрки (Маггинс)',
      'all-fives-2v2': 'Все пятёрки (Маггинс, 2 на 2)',
      telefon: 'Телефон',
      'telefon-2v2': 'Телефон (2 на 2)',
    },
    on: 'Вкл',
    off: 'Выкл',
    namePrompt: 'Введите ваше имя:',
  },
  about: {
    version: 'Версия {{version}}',
    tech: 'TypeScript + Canvas',
  },
  rules: {
    screenTitle: 'Правила',
    goat: {
      title: 'Козёл',
      items: {
        setup: {
          title: 'Начало',
          body: 'Набор «дубль-шесть» (28 костей). Каждый берёт по 7 костей при любом числе игроков, остальные уходят в базар (на двоих — 14 костей, на троих — 7, на четверых базара нет). Играют пара на пару — партнёры сидят друг напротив друга — или каждый сам за себя, от двух до четырёх человек.',
        },
        lead: {
          title: 'Первый ход',
          body: 'В первой раздаче ходит тот, у кого [1|1], — и начинает именно с неё. Если [1|1] лежит в базаре, начинают с самого младшего дубля на руках, а если дублей ни у кого нет — с самой младшей кости. В следующих раздачах первым ходит победитель предыдущей, любой костью.',
        },
        play: {
          title: 'Ход',
          body: 'Кость прикладывают к одному из двух концов цепочки. Дубли кладут поперёк, но ветвей от них нет — у цепочки всегда ровно два конца. Во время раздачи очки не начисляются. Нечем ходить — берите из базара, пока не найдётся подходящая кость; базар пуст — пропускайте ход.',
        },
        ending: {
          title: 'Конец раздачи',
          body: 'Раздача заканчивается либо «домино!» — кто-то выложил последнюю кость, — либо «рыбой»: ходить никто не может, а базар пуст. В «рыбе» выигрывает сторона, у которой на руках меньше всего очков.',
        },
        scoring: {
          title: 'Запись очков',
          body: 'Победители ничего не пишут, а каждая проигравшая сторона записывает себе очки, оставшиеся на руках (в игре пара на пару — сумму обоих партнёров). Если на руках остался один [0|0], он стоит 25, один [6|6] — 50, а [0|0] вместе с [6|6] — 75. «Яйца»: если в «рыбе» меньше всего очков сразу у нескольких сторон, ничего не записывается, а очки переходят к проигравшему следующей раздачи.',
        },
        match: {
          title: 'Козёл',
          body: 'Игра идёт до 101 очка. Кто набрал 101, тот проиграл — он и есть «козёл», ему «забили козла». В игре каждый сам за себя побеждает тот, у кого меньше всего очков.',
        },
        options: {
          title: 'Дополнительные правила',
          body: 'Два правила по желанию, оба по умолчанию выключены в настройках. «Запись с 13 очков»: пока у стороны 0, штраф за раздачу записывается ей, только если он не меньше 13. «Лысый»: кто вышел, положив последней кость [0|0], сразу заканчивает партию — его сторона побеждает.',
        },
      },
    },
    'all-fives': {
      title: 'Все пятёрки (Маггинс)',
      items: {
        setup: {
          title: 'Начало',
          body: 'Используется набор «дубль-шесть» (28 костей). Каждый игрок берёт стартовую руку (по 7 на двоих, по 6 на троих, по 5 на четверых). Оставшиеся кости — базар. Игру начинает тот, у кого есть самый тяжёлый дубль; в следующих раздачах ход переходит по часовой стрелке.',
        },
        play: {
          title: 'Ход',
          body: 'В свой ход выложите кость, у которой одна из половин совпадает с открытым концом одного из лучей цепочки. Если хода нет — берите из базара, пока не появится; если базар пуст — пас. «Спиннером» становится первый НАКРЫТЫЙ дубль: от его длинных сторон отходят два дополнительных луча, всего до четырёх открытых концов. Дубль на конце луча — это ещё открытый конец, поэтому он получает боковые лучи лишь после того, как игра пройдёт дальше; дубль, с которого начали раздачу, ждёт, пока не будут застроены обе его стороны.',
        },
        scoring: {
          title: 'Очки',
          body: 'После каждого хода сложите открытые концы активных лучей. Если сумма кратна 5 — вы получаете столько очков. Дубли считаются обеими половинами в боковом положении; спиннер считается как 2 × лицо, пока его перпендикулярные лучи не накрыты другими костями.',
        },
        muggins: {
          title: 'Muggins',
          body: 'В строгом режиме нужно успеть нажать «Claim Muggins» в течение нескольких секунд — иначе очки сгорают. В мягком режиме очки начисляются автоматически. В сетевой игре их может перехватить соперник, заметивший пропущенный счёт.',
        },
        ending: {
          title: 'Окончание',
          body: 'Раздача заканчивается, когда у игрока закончились кости («ушёл») или никто не может ходить (тупик). Победитель получает бонус — сумму оставшихся очков противников, округлённую до ближайшего числа, кратного 5. Партия заканчивается, когда игрок (или команда в 2 на 2) достигает целевого счёта.',
        },
      },
    },
    telefon: {
      title: 'Телефон',
      items: {
        setup: {
          title: 'Начало',
          body: 'Используется набор «дубль-шесть» (28 костей). Каждый игрок берёт ровно 7 костей — независимо от числа игроков. При четверых игроках базар стартует пустым (вариант без добора). Первую раздачу начинает тот, у кого на руках кость [2|3]; если [2|3] в базаре — выбирается [1|1] → [2|2] → … → [6|6], затем самая лёгкая кость в любой руке. Открывающая кость фиксированная — лидер ОБЯЗАН выложить именно её.',
        },
        rotation: {
          title: 'Смена хода',
          body: 'После каждой раздачи право первого хода передаётся СЛЕДУЮЩЕМУ игроку по часовой стрелке — оно НЕ остаётся у победителя. Тот, кто открыл текущую раздачу, не открывает следующую: её начинает сосед слева, независимо от того, кто выиграл или попал в тупик. Каждый круг открывает новый игрок.',
        },
        scoring: {
          title: 'Очки',
          body: 'Очки за ходы внутри раздачи считаются по правилу «кратно 5» (как во «Всех пятёрках» — сумма открытых концов). Особенность лидирующего хода: он приносит очки ТОЛЬКО если первой выложен [5|5] (открытые концы 5 + 5 = 10). Любая другая открывающая кость даёт 0, даже если сумма её открытых концов уже кратна 5.',
        },
        ending: {
          title: 'Окончание',
          body: 'Как во «Всех пятёрках»: раздача заканчивается на «ушёл» или тупике, бонус проигравших округляется до ближайшего числа, кратного 5. Партия заканчивается, когда игрок (или команда в 2 на 2) достигает целевого счёта.',
        },
      },
    },
  },
  banner: {
    yourTurn: 'Ваш ход',
    seatTurn: 'Ход — {{seat}}',
    claimMuggins: '{{seat}} — забрать Muggins?',
    handOver: 'Раздача окончена',
    matchOver: 'Партия окончена',
    lastPlay: '{{actor}} сыграл [{{a}},{{b}}].',
    lastPlayScored: '{{actor}} сыграл [{{a}},{{b}}], набрал {{points}}.',
    lastPlayWentOut: '{{actor}} сыграл [{{a}},{{b}}] и ушёл.',
    lastPlayScoredWentOut: '{{actor}} сыграл [{{a}},{{b}}], набрал {{points}} и ушёл.',
    lastDraw: '{{actor}} взял кость.',
    lastPass: '{{actor}} пропустил.',
    lastClaim: '{{actor}} забрал +{{points}}.',
    lastClaimWithTile: '{{actor}} забрал +{{points}} за [{{a}},{{b}}].',
  },
  actionBar: {
    draw: 'Взять',
    claimMuggins: 'Claim Muggins',
  },
  playerInfo: {
    score: 'Счёт',
    tiles: 'Костей',
    penalty: 'Штраф',
  },
  curtain: {
    title: 'Ход — {{seat}}',
    subtitle: 'Передайте устройство и продолжайте, когда будете готовы.',
    ready: 'Я готов',
  },
  result: {
    handOver: 'Раздача окончена',
    matchOver: 'Партия окончена',
    blocked: '{{names}} победили в тупике.',
    wentOut: '{{names}} ушёл.',
    matchWon: 'Победа в партии: {{names}}.',
    drawn: 'Тупик.',
    nextHand: 'Следующая раздача',
    newMatch: 'Новая партия',
    menu: 'Меню',
    seatNumber: 'И{{number}}',
    teamNumber: 'К{{number}}',
    penalty: {
      domino: 'Домино! Победа в раздаче: {{names}}.',
      fish: 'Рыба! Меньше всего очков: {{names}}.',
      eggs: 'Яйца! В следующую раздачу переходит штраф: {{points}}.',
      written: '{{names}}: штраф +{{points}}.',
      bald: 'Лысый козёл! {{name}}: последняя кость [0|0].',
      goat: '{{name}} — козёл!',
      goats: '{{names}} — козлы!',
    },
  },
  historyList: {
    title: 'История партий',
    empty: 'Сохранённых партий пока нет — сыграйте, чтобы начать список.',
    winnerTemplate: 'Победа {{names}}',
    draw: 'Ничья',
    unfinished: 'Не завершена',
    movesCount: '{{count}} ходов',
    deleteAria: 'Удалить партию',
    deleteConfirm: 'Удалить эту сохранённую партию?',
    downloadAria: 'Скачать журнал партии',
    verifyAria: 'Проверить раздачи матча',
    modes: {
      ai: 'Против бота',
      local: 'Локально',
      online: 'По сети',
    },
    accountSection: {
      title: 'Ваш аккаунт',
      loading: 'Загрузка…',
      empty: 'Пока нет онлайн-партий.',
      statsLine: '{{wins}}В – {{losses}}П – {{draws}}Н ({{played}} сыграно)',
    },
    deviceSection: {
      title: 'На этом устройстве',
    },
  },
  verify: {
    title: 'Проверка матча — {{date}}',
    source: 'Источник',
    chain: 'Цепочка',
    signedBy: 'Подписано',
    handLabel: 'Раздача {{n}}',
    seedTemplate: 'сид раздачи {{seed}}',
    roundTemplate: 'раунд {{n}}',
    allOk: 'Все {{count}} раздач проверены.',
    someFail: 'Проверено {{ok}} из {{count}} раздач — {{bad}} с ошибкой.',
    someUnverified:
      'Проверено {{ok}} из {{count}} раздач — {{unverified}} без подтверждения (сбой drand).',
    verifying: 'Проверка подписей…',
    statusVerified: 'Подтверждено',
    statusSeedMismatch: 'Раздача подделана',
    statusSigInvalid: 'Подпись недействительна',
    statusUnverified: 'Без подтверждения',
    statusPending: 'Проверяется…',
    downloadProof: 'Скачать пакет подтверждений',
    close: 'Закрыть',
    explainer:
      'Каждая раздача проверяется по BLS-подписи закреплённой цепочки drand — пакет можно перепроверить через drand CLI.',
  },
  replay: {
    controls: {
      first: 'В начало',
      previous: 'Назад',
      play: 'Играть',
      pause: 'Пауза',
      next: 'Вперёд',
      last: 'В конец',
      speed: 'Скорость',
      backToHistory: 'К списку',
      backToMenu: 'В меню',
    },
  },
  online: {
    create: {
      title: 'Создать комнату',
      codeLabel: 'Код комнаты',
      share: 'Поделитесь этим кодом с соперниками',
      variantLabel: 'Играем в {{variant}}',
      seatCountLabel: 'Игроков',
      seatLabel: 'Ваше место',
      create: 'Создать',
    },
    share: {
      copyCode: 'Скопировать код',
      copyLink: 'Скопировать ссылку',
      copied: 'Скопировано!',
    },
    join: {
      title: 'Войти в комнату',
      codeLabel: 'Введите код комнаты',
      typeHint: 'Введите код из 4 символов',
      enterHint: 'Нажмите Enter, чтобы войти',
      submit: 'Войти',
      variantLabel: 'В комнате играют в {{variant}}',
      paste: 'Вставить',
    },
    verifiable: {
      hostBadge: 'Проверяемое перемешивание',
      hostHint: 'Оба игрока должны согласиться, чтобы раздача использовала подписанные drand данные.',
      joinerOn: 'Хост использует проверяемое перемешивание — результаты раздачи можно проверить криптографически.',
      joinerOff: 'Хост не использует проверяемое перемешивание.',
    },
    status: {
      connecting: 'Подключение',
      creating: 'Создаём комнату',
      waitingForOpponent: 'Ждём игроков',
      opponentJoined: 'Игроки присоединились',
      joining: 'Входим',
      couldNotJoin: 'Не удалось войти',
      error: 'Ошибка соединения',
    },
    resumeModal: {
      reconnectingTitle: 'Переподключение…',
      reconnectingBody: 'Возвращаемся в игру…',
      seatTakenTitle: 'Место занято',
      seatTakenBody: 'Это место принадлежит другому аккаунту. Войдите под тем аккаунтом или начните новую игру.',
      roomGoneTitle: 'Стол закрыт',
      roomGoneBody: 'Эта партия завершена — стол закрыт.',
      roomFullTitle: 'Комната заполнена',
      roomFullBody: 'Все места за этим столом заняты, и ни одно из них не ваше.',
      anonymousTitle: 'Не можем подтвердить, что это место ваше',
      anonymousBody: 'В этом браузере нет записи об этой игре. Войдите в аккаунт перед следующей онлайн-игрой, и ваше место будет доступно с любого устройства.',
      unreachableTitle: 'Не удалось связаться с сервером',
      unreachableBody: 'Сервер не отвечает. Проверьте соединение и попробуйте снова.',
      signIn: 'Войти',
      viewSaved: 'Посмотреть сохранённую позицию',
      retry: 'Повторить',
      discard: 'Удалить',
    },
    overlay: {
      opponentDisconnected: '{{name}} отключился',
      waitingForReconnection: 'Ждём переподключения {{countdown}}',
      reconnecting: 'Переподключаемся',
      restoringGame: 'Восстановление игры {{countdown}}',
      connectionLost: 'Соединение потеряно',
      gameEnded: 'Игра завершена',
      rematchOffered: 'Реванш предложен',
      waitingForOpponent: 'Ждём {{name}}',
      rematchRequested: '{{name}} хочет реванш',
      rematchDeclined: '{{name}} отклонил реванш',
      gameOverWin: 'Победа!',
      gameOverLoss: 'Поражение',
      gameOverDraw: 'Ничья',
      gameOverPrompt: 'Сыграем ещё?',
      buttons: {
        leave: 'Выйти',
        rematch: 'Реванш',
        returnToMenu: 'В меню',
        cancel: 'Отмена',
        accept: 'Принять',
        decline: 'Отклонить',
      },
    },
  },
  pwa: {
    updateAvailable: {
      title: 'Доступно обновление',
      body: 'Готова новая версия игры. Обновите страницу, чтобы загрузить её.',
      refresh: 'Обновить',
      later: 'Позже',
    },
  },
};
